import React from "react"
import { useColors } from "@mallardbay/lib-react-components"

import ResponsiveBlock from "~components/shared/responsive-block"
import Divider from "~components/shared/divider"
import type {
    PublicListingFieldsFragment,
    SearchListingFieldsFragment,
} from "~graphql/generated/graphql"
import ListingsCollection from "~components/shared/collections/listings-collection"
import COPY from "~config/copy-constants"
import Box from "~components/shared/todo-lib-react-components/box"
import { useSearchListings } from "~utils/use-listings"
import LoadingOrErrorContainer from "~components/shared/todo-lib-react-components/loading-or-error-container"

interface Props {
    readonly listing: SearchListingFieldsFragment | PublicListingFieldsFragment
}

export default function ListingSuggestionsBasedOnListing({ listing }: Props) {
    const styles = useStyles()

    const { isLoading, error, listings } = useSearchListings({
        searchParams: {
            state: listing.location?.state,
        },
    })

    const suggestionsCollectionLabel = `${COPY.OTHER_ADVENTURES_IN} ${listing.location?.state}`

    // Move current listing to top of the listing
    const listingsWithoutCurrentListing = listings.filter(
        (listingLocal) => listingLocal.id !== listing.id
    )

    if (!listingsWithoutCurrentListing.length) return null

    return (
        <LoadingOrErrorContainer
            isLoading={isLoading}
            error={error}
            shouldRenderChildren={!isLoading && !error}
        >
            <Divider />
            <Box style={styles.root}>
                <ResponsiveBlock>
                    <ListingsCollection
                        listings={listingsWithoutCurrentListing}
                        label={suggestionsCollectionLabel}
                    />
                </ResponsiveBlock>
            </Box>
        </LoadingOrErrorContainer>
    )
}

function useStyles() {
    const colors = useColors()

    const root = {
        backgroundColor: colors.cardBackgroundColor,
        paddingTop: "10px",
        paddingBottom: "48px",
    }

    return {
        root,
    }
}
